<div class="shop-add component-container component-page-container action-button-wrapper p-overflow-hidden">
    <div class="sh-page-wrapper bottom-action-mg">
        <div>
            <custom-panel
                class="flex flex-grow"
                header="Floorplan placówki"
                [saveButtonText]="saveButtonText"
                resetButtonText="Usuń floorplan"
                (componentReset)="openDeleteDialog()"
                (componentSave)="openImportDialog()"
                [areButtons]="true"
                [saveDisabled]="isLoadingFloorplan || isDeletingFloorplan"
                [resetDisabled]="isLoadingFloorplan || isDeletingFloorplan || !this.storeData.FloorPlanFileId"
            >
                    <div class="pv-xs" fxLayout="column" fxLayoutAlign="center center" panel-body>
                        <button-spinner class="ml-xxs" diameter="200" [inProgress]="isLoadingFloorplan">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <img *ngIf="isFloorplan" width="1000px" height="auto" [src]="floorplanImg" alt="Zdjęcie floorplanu" (load)="isLoadingFloorplan = false">
                                <h3 class="pv-xl" *ngIf="!isFloorplan">
                                    Aktualnie ta placówka nie ma floorplanu. Aby dodać floorplan wciśnij przycisk "Prześlij floorplan"
                                </h3>
                            </div>
                        </button-spinner>
                    </div>
            </custom-panel>
        </div>
    </div>

</div>

<pr-floorplan-shelves customCellName="Meters" [storeId]="storeId"></pr-floorplan-shelves>
